module.exports = __webpack_public_path__ + "static/media/biDEGEN.c40b16be.png";